
<div class="trinka_cloud_wrap">
    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>文法チェックAPI</h1>
                            <h2>シンプルで高速な<br/>
                                AI文法チェックAPI</h2>
                                <p>TrinkaのシンプルなRESTful APIが、お客様のアプリケーション上でのリアルタイムの強力な英文チェックを可能にします。</p>
                                <div class="btn-group">
                                    <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                                    data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お問い合わせ</button>
                                    <a href="https://calendly.com/trinkaai/meet" target="_blank"  id="autoEditGetStart" class="outline-btn">コードのサンプル</a>
                                </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="../../../assets/images/trinka-api.svg" class="img-fluid" alt="文法 チェック API">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<section class="section-pd trinka-key-features">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2>TrinkaのAPIをご活用いただけるシステム/アプリの例</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="gt-features three-coloum">
                    <span class="hr-line"></span>
                    <span class="vr-line l25"></span>
                    <span class="vr-line l50"></span>
                    <span class="vr-line l75"></span>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>コンテンツ管理システム
                        </h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>オンラインライティングプラットフォーム</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>メッセージ/SNSアプリ</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                          </svg>
                        <h6>CRM/ヘルプデスク・ソフトウェア</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                          </svg>
                        <h6>クライアントへのメール</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                          </svg>
                        <h6>プロジェクト管理ソフトウェア</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                          </svg>
                        <h6>eラーニングプラットフォーム</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                          </svg>
                        <h6>学習管理システム</h6>
                    </div>
                </div>            
            </div>
        </div>
    </div>
</section>

<div class="writeToolboxs_section section-pd pb-0">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-112">
                <div class="trinka-title mb-0 text-center">
                    <h2>お客様アプリ上でユーザがテキスト入力中の校正を受けることも
                        お客様アプリから校正対象ファイルをアップロードして一括校正を受けることも可能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinkaの文法チェックAPIなら、ワークフローや技術に合わせたシームレスな統合を実現できます。</p>
                </div>
            </div>
        </div>
    </div>

    <section class="section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2 wrapper_left">
                        <h3>お客様のアプリでユーザが英文テキスト入力時に<br/>
                            リアルタイムで校正内容を返し、表示いただけるAPI</h3>
                        <p>TrinkaのリアルタイムAPIは、お客様の学習プラットフォーム、テキストエディタ、チャットアプリケーションなど、瞬時に文章を修正する必要があるアプリケーションの機能をさらにパワーアップします。</p>
                        <ul>
                            <li>行単位、段落単位、またはそれ以上の分量での英文修正に対応</li>
                            <li>すべての入力フォーマットに対応するシンプルなレスポンスペイロード</li>
                            <li>テキスト量またはAPIコール数に応じたお支払い方法を選択可</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image">
                        <img src="../../../assets/images/Real-time Check API.svg" alt="リアルタイムチェックAPI - 英文校正" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-pd list-wrapper-style-2 pt-0">
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2 pr-80 wrapper_left">
                        <h3>Wordファイルなどをアップロードし、<br/>
                            校正結果を反映したファイルをダウンロードいただくAPI</h3>
                        <p>Trinkaのファイル校正APIなら、複雑なシステム統合や大量のAPIコールは不要で、様々なワークフローをサポートします。</p>
                        <ul>
                            <li>APIコール1回で校正済みファイルを取得</li>
                            <li>バージョン管理およびユーザーコントロールのための変更履歴機能</li>
                            <li>評価のためのライティング品質スコアと修正サマリーの作成</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image">
                        <img src="../../../assets/images/file-edit-api.png" alt="ファイル編集API - 英文チ ェッカー" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>


<div class="cloud_key_features section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka文法チェックAPIの使用例</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>eラーニングアプリケーション</h3>
                    <p>Trinkaの文法チェックAPIで、学術英語を適切に推敲できる学習アプリの開発が可能に
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>出版・編集</h3>
                    <p>Trinkaの文法チェックAPIがスタッフの編集をアシスト。時間とコストを削減し品質を向上させます</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>学生のコミュニケーション</h3>
                    <p>Trinkaの文法チェックAPIが、フォーラムやグループでの円滑なコミュニケーションを促し、学生のエンゲージメント力を向上させます</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>ビジネス</h3>
                    <p>明瞭性、一貫性、ブランディングを維持した質の高い文章作成のため、複数の企業にTrinkaの文法チェックAPIを活用いただいています
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>生産性向上プラットフォーム</h3>
                    <p>生産性向上プラットフォームにTrinkaのリアルタイムAPIを取り入れることで、ライティングサポート機能がユーザーの生産性をさらに向上させます
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Trinka文法チェックAPIが、あなたのアプリをパワーアップ</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup"
                    class="white-btn" type="submit">お問い合わせ</button>
                </div>
            </div>
        </div>  
    </div>
</div>

<div class="cloud_key_features cloudKeyBenefitSection cs-section" style="padding-bottom: 40px !important;">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>シンプルなAPIでTrinkaの全機能にアクセス</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-5 col-xl-5">
                <div class="cs-left-section">
                    <p>文法チェックAPIにより、高度な英文法の修正からトーンやスタイルの強化まで、包括的なライティングサポートが可能に。ニーズに合った機能をお選びいただけます。</p>

                    <p>文法・スペルチェックAPIが、学術的なライティングの慣習に合わせて英文を洗練。英語のミスがないか悩むことなく、書く人が自分のアイデアに集中できるようになります。</p>

                    <p>また、適正な専門用語、学術的文体、偏向のない言い回し、適切な言葉遣い、スタイルガイドへの準拠などの追加機能も豊富です。</p>
                </div>
            </div>
            <div class="col-lg-7 col-xl-7">
                <div class="xs-features-api">
                    <span class="hline"></span>
                    <span class="vline"></span>
                    <span class="vline vline2"></span>
                    <div class="row match-box">
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Advanced-Grammar.png" alt="高度な文法 - 文法 チェック" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading ">
                                        <h3>高度な文法修正</h3>
                                    </div>
                                    <p>学術的・フォーマルなコミュニケーションに最適
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_ExpertProofreading.png" alt="テーマに応じた修正 - 英文校正" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>テーマに応じた修正</h3>
                                    </div>
                                    <p>文書のテーマの自動検出とそれに応じた修正提案
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_title.png" alt="文脈に即したスペル - 英文チ ェッカー" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>文脈に即したスペル</h3>
                                    </div>
                                    <p>内容・文脈に基づいた適正な用語の選択
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_Pass_02.png" alt="コツと説明 - 英文 チェック ai" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>コツと説明</h3>
                                    </div>
                                    <p>ライティングスキル向上につながるAIによる修正箇所の説明
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Non-standard-2.png" alt="スタイルガイドへの準拠 - 文法 チェック" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>スタイルガイドへの準拠</h3>
                                    </div>
                                    <p>スタイルガイド（AMA、APAなど）に基づいた修正を提案
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media no-border-before">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_Dictionary.png" alt="マイ・ディクショナリー - ai英文校正" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>マイ・ディクショナリー</h3>
                                    </div>
                                    <p>効果的なブランディングを可能にするカスタマイズできる辞書
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="section-pd section-purple">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h2>お客様に寄り添った柔軟な料金設定をご用意しています</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>お客様それぞれのご利用方法やご予算に合わせ、最適な料金プランをご提案します。テキストの分量、ファイルサイズ、APIコール数など、料金の算出基準はお客様にとって最もお得なものに設定します。</p>
                    <div class="btn-group justify-content-center mt-4">
                        <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お見積もりはこちら</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>万全のセキュリティ</h3>
                        <p>Trinkaは、データの安全性とプライバシーを最重視した設計になっています。お客様のデータは高度に暗号化され、安全に保管されます。第三者がお客様のデータにアクセスすることはありません。ライティングの提案後に、データを完全に抹消するプランもご用意しています。
                        </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/safe-secure.png" alt="万全のセキュリティ - 英文校正" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>AIについて</h3>
                        <p>Trinkaは、コミュニケーションの障壁がない未来を願って、言語学者、医学校正者、データサイエンティスト、エンジニアらのチームによって開発されました。</p>
                        <p>Trinkaは、最新の機械学習（ML）と自然言語処理（NLP）の技術を使用して、文法の誤りを特定し、言語の改善案を提案します。医学、ライフサイエンス、生物学、物理科学、工学、人文科学、ビジネス、芸術を含む1300以上の分野の上質な論文や記事を数百万単位で読み込むことでAIが学習し、最適な提案をします。
                        </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/about-ai.png" alt="AIについて - 英文 チェック ai" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<div class="faqQuestionAnwser section-pd pt-0" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Trinka文法チェックAPIについてよくあるご質問</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinkaの文法・スペルチェックAPIはどんな場面で利用できますか？</a>
                                </div>
    
                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaの文法チェックAPIは様々な用途に使用できます。以下は、現在のお客様によるAPIの使用用途の一部です。</p>
                                        <ol>
                                            <li>作文の自動採点</li>
                                            <li>テキストエディタ・アプリへの文法チェック機能の追加</li>
                                            <li>校正サービスの品質向上</li>
                                            <li>Webサイトの文法チェック</li>
                                            <li>英語学習者へのフィードバック</li>
                                            <li>訳文の文法ミスチェック</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        テキストエディタにリアルタイムチェックを組み込むことはできますか？</a>
                                </div>
    
                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい、できます。テキストエディタへのリアルタイムチェックの組み込みは、一般的なご使用方法です。昨今、ライティング時の文法チェック機能は多くの人の期待するものとなっています。</p>
                                        <p>Trinkaでは、どのようなオンラインテキストエディタにも文法チェック機能を容易に組み込めるようにしました。簡単に使える文法チェックのコンポーネントで、短時間でお客様のテキストエディタに文法とスペルチェック機能を組み込むことができます。コンポーネントのインターフェイスも簡単にカスタマイズでき、企業ごとのスタイルにも合わせられます。また、キーボードショートカットなどのカスタマイズも可能です。</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        まずは無料で試せますか？
                                    </a>
                                </div>
    
                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい、無料でAPIをお試しいただけます。お気軽に<a id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup" class="text-link">お問い合わせ</a>ください。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
    
                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        APIに関する解説書はありますか？
                                    </a>
                                </div>
    
                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい、ご用意しています。Trinka APIをスムーズに統合していただくために、詳細な仕様書とサポートを提供しています。お気軽に<a id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup" class="text-link">お問い合わせ</a>ください。</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        文法チェックAPIの使用を開始する際に、料金は必要ですか？
                                    </a>
                                </div>
    
                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>いいえ、セットアップ費用は一切かかりません。お気軽に<a id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup">お問い合わせ</a>ください。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="modal custom_modal_popup enterprisePopup sampleCode" id="sampleCode">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body">
                <div class="code-block">
                    <div class="closed_icons">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="row no-margin">
                        <div class="col-sm-6 no-gutter">
                            <h3 class="code-title">コードのサンプル:</h3>
                            <div class="code-bloc">
                            <pre class="html ">
                                <div class="style-4 code">
1 curl --location --request POST
2 <span class="tx-green">'https://check.trinka.ai/languagecheck/v1/check' \</span>
3 --header 'x-api-key: xxxxzxzxzxzxzxzxzxzxz \
4 --header 'Content-Type: application/json' \
5
6 --data-raw '<span class="tx-yellow">&#123;</span>
7 <span class="tx-l-blue">"paragraph"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment.         
<span class="tx-white">8</span>    It is utilized as not only a structural component 
<span class="tx-white">9</span>    but also an interior finishing material that can be directly 
<span class="tx-white">10</span>    seen and touched in different buildings, such as houses, 
<span class="tx-white">11</span>    offices, and public facilities. Moreover, it brings a 
<span class="tx-white">12</span>    positive impression, such as comfort and relaxation, 
<span class="tx-white">13</span>    among residents and users."</span>,
14 <span class="tx-l-blue">"language"</span>: <span class="tx-orange">"US"</span>
15 <span class="tx-yellow">&#125;</span>'
                                </div>
                            </pre>
                            </div>
                        </div>
                        <div class="col-sm-6 no-gutter">
                            <h3 class="code-title">レスポンスのサンプル:</h3>
                            <div class="code-bloc">
                            <pre class="html style-4">
                                <div class="style-4 code ">
1 <span class="tx-yellow">&#123;</span>
2    <span class="tx-l-blue">"status"</span>: <span class="tx-d-blue">true</span>,
3   <span class="tx-l-blue">"input_para"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment. It is utilized as not only a structural component but also an interior finishing material that can be directly seen and touched in different buildings, such as houses, offices, and public facilities. Moreover, it brings a positive impression, such as comfort and relaxation, among residents and users."</span>,
4    <span class="tx-l-blue">"sentences"</span>: <span class="tx-pink">&#91;</span>
5        <span class="tx-d-blue">&#123;</span>
6            <span class="tx-green">/*** Input sentence and the offsets for the sentence ***/</span>
7            <span class="tx-l-blue">"sentence"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment."</span>,
8           <span class="tx-l-blue">"begin"</span> <span class="tx-l-green">0</span>,
9            <span class="tx-l-blue">"end"</span>: <span class="tx-l-green">54</span>,
10            <span class="tx-l-blue">"result"</span>: <span class="tx-yellow">&#91;</span>
11                <span class="tx-pink">&#123;</span>
12                   <span class="tx-green">/*** Detected issue and its details ***/</span>
13                    <span class="tx-l-blue">"start_index"</span>: <span class="tx-l-green">35</span>,
14                    <span class="tx-l-blue">"end_index"</span>: <span class="tx-l-green">40</span>,
15                    <span class="tx-l-blue">"covered_text"</span>: <span class="tx-orange">"indoor"</span>,
16                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
17                        <span class="tx-orange">"the indoor"</span>
18                    <span class="tx-d-blue">&#93;</span>,
19                    <span class="tx-green">/***  Suggestion for replacement or a comment ***/</span>
20                    <span class="tx-l-blue">"comment"</span>: <span class="tx-d-blue">&#91;</span>
21                        <span class="tx-orange">"Insert 'a', 'an', or 'the' before 'indoor'."</span>
22                    <span class="tx-d-blue">&#93;</span>,
23                    <span class="tx-green">/*** Error categorization ***/</span>
24                    <span class="tx-l-blue">"error_category"</span>: <span class="tx-d-blue">&#91;</span>
25                        <span class="tx-orange">"Grammar-Article"</span>
26                    <span class="tx-d-blue">&#93;</span>,
27                    <span class="tx-green">/*** Replacement text for the detected error ***/</span>
28                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
29                        <span class="tx-d-blue">true</span>
30                    <span class="tx-d-blue">&#93;</span>,
31                <span class="tx-pink">&#125;</span>
32            <span class="tx-yellow">&#93;</span>
33        <span class="tx-d-blue">&#125;</span>,
34        <span class="tx-d-blue">&#123;</span>
35            <span class="tx-green">/*** Input sentence and the offsets for the sentence ***/</span>
36            <span class="tx-l-blue">"sentence"</span>: <span class="tx-orange">"It is utilized as not only a structural component but also an interior finishing material that can be directly seen and touched in different buildings, such as houses, offices, and public facilities."</span>,
37            <span class="tx-l-blue">"begin"</span> <span class="tx-l-green">55</span>,
38            <span class="tx-l-blue">"end"</span>: <span class="tx-l-green">254</span>,
39            <span class="tx-l-blue">"result"</span>: <span class="tx-yellow">&#91;</span>
40                <span class="tx-pink">&#123;</span>
41                    <span class="tx-green">/*** Detected issue and its details ***/</span>
42                    <span class="tx-l-blue">"start_index"</span>: <span class="tx-l-green">6</span>,
43                    <span class="tx-l-blue">"end_index"</span>: <span class="tx-l-green">13</span>,
44                    <span class="tx-l-blue">"covered_text"</span>: <span class="tx-orange">"utilized"</span>,
45                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
46                        <span class="tx-orange">"used"</span>
47                    <span class="tx-d-blue">&#93;</span>,
48                    <span class="tx-green">/***  Suggestion for replacement or a comment ***/</span>
49                    <span class="tx-l-blue">"comment"</span>: <span class="tx-d-blue">&#91;</span>
50                        <span class="tx-orange">"Plain language tip: Replace \"utilized\" with \"used\" if it fits the context."</span>
51                    <span class="tx-d-blue">&#93;</span>,
52                    <span class="tx-green">/*** Error categorization ***/</span>
53                    <span class="tx-l-blue">"error_category"</span>: <span class="tx-d-blue">&#91;</span>
54                        <span class="tx-orange">"Enhancement"</span>
55                    <span class="tx-d-blue">&#93;</span>,
56                    <span class="tx-green">/*** Replacement text for the detected error ***/</span>
57                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
58                        <span class="tx-d-blue">true</span>
59                    <span class="tx-d-blue">&#93;</span>,
60                <span class="tx-pink">&#125;</span>
61            <span class="tx-yellow">&#93;</span>
62        <span class="tx-d-blue">&#125;</span>,
63    <span class="tx-pink">&#93;</span>,
64    <span class="tx-l-blue">"message"</span>: <span class="tx-orange">"Success"</span>
65 <span class="tx-yellow">&#125;</span> 
                                </div>
                            </pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<app-enterprise-modal></app-enterprise-modal>